// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"901d4bfb","213":"8d189a05","304":"9eaebb40","389":"c823d222","451":"bafdbb9f","453":"21e9e00e","732":"c1924de9","892":"8ee28691","959":"6cd602b0","977":"fdba7d61","990":"57280b97"}[chunkId] + ".chunk.js";
};